module.exports = __webpack_public_path__ + "static/bizSafeStarCert2024-086662bf1eab9b56116ae1ab4245240c.svg";